import {useEffect, useState} from "react";
import FieldError from "@/components/FieldError";
import {useValidation} from "@/validation";

export default function Select({label, options, value, name, description, placeholder, disabled, required, onChange}) {
    const {isFieldValid, invalidMessage, showErrors} = useValidation()

    const [touched, setTouched] = useState(false)

    const valid = isFieldValid(name)
    const invalidMsg = invalidMessage(name)
    const showError = touched && !valid && invalidMsg

    const handleChange = (e) => {
        onChange && onChange(e.target.value)
    }

    useEffect(() => {
        if (showErrors) {
            setTouched(true)
        }
    }, [showErrors])

    return (
        <fieldset className="daisy-fieldset">
            {label && (
                <legend className="daisy-fieldset-legend text-label inline">
                    {label}{required && ' *'}
                    {description && <span className={"input-description"}> {description}</span>}
                </legend>
            )}
            <select
                className={`daisy-select w-full ${!showError ? 'daisy-select-neutral' : 'daisy-select-error'}`}
                name={name}
                value={value || ""}
                onChange={handleChange}
                disabled={disabled !== undefined ? disabled : false}
            >
                <option value="">{placeholder || "-- Select --"}</option>
                {options && options.map((option, i) => (
                    <option value={option.value || option.label || option} key={i}>{option.label || option.value || option}</option>
                ))}
            </select>
            {showError && (
                <FieldError message={invalidMsg} />
            )}
        </fieldset>
    )
}
